export default {
  title: 'Studio (V2)',
  description: 'Crea e gestisci il sito web del ristorante con il nuovo Website Studio.',
  retry: 'Riprova',
  deleted: 'Progetto eliminato.',
  errors: {
    load: 'Impossibile caricare il progetto Studio (V2).',
    create: 'Impossibile creare il progetto. Riprova.',
    delete: 'Impossibile eliminare il progetto. Riprova.',
  },
  EmptyState: {
    title: 'Nessun progetto Studio (V2) per ora',
    description: 'Crea un progetto per realizzare il sito web nel nuovo Website Studio. Studio (V1) rimane invariato.',
    description_no_access: 'Un onboarding manager può creare il progetto per questo brand.',
    create: 'Crea progetto',
  },
  ProjectCard: {
    unnamed: 'Progetto senza nome',
    edit: 'Modifica in Studio',
    delete: 'Elimina',
    open: 'Apri',
    no_domain: 'Ancora nessun dominio',
    fields: {
      uuid: 'UUID',
      domain: 'Dominio',
      websites: 'Siti web',
    },
    delete_confirm: {
      title: 'Eliminare questo progetto?',
      description:
        'Verranno rimossi il progetto Studio (V2) e i relativi siti web. Potrai crearne uno nuovo più tardi.',
      ok: 'Elimina',
      cancel: 'Annulla',
    },
  },
};
